import { tryParseNumber } from '~/utils';
import { QueryParameterSchema } from '../../context/QueryParameterContext';

export const pageSizeParameter: QueryParameterSchema<'pageSize'> = {
  getDefaultValue: ({ defaultParameters }) => defaultParameters.pageSize,
  getValue: ({ parameters }) => parameters.pageSize,
  toUrlSearchParams: ({ value }) => ({ 'page[size]': `${value}` }),
  toSearchQuery: ({ value }) => ({ 'page[size]': value }),
  fromUrlSearchParams: ({ urlSearchParams, defaultValue }) => ({
    pageSize: tryParseNumber(urlSearchParams.get('page[size]')) || defaultValue,
  }),
  sanitize: ({ value, defaultValue, staticProps }) => {
    const validPageSizes = staticProps.referenceData.pageSizes;
    if (value && validPageSizes.includes(value)) return { pageSize: value };
    return { pageSize: defaultValue };
  },
};
